import React from 'react';

import { cx } from '../../../utils/cx';
import { translate } from '../../../utils/wp.js';

export function NightsSelector({nights, value, disabled, onChange}) {
    return (
        <div
            className={cx(
                'hotel-picker hotel-picker--nights basis-full flex flex-wrap justify-between gap-x-0.5 sm:basis-auto sm:justify-start',
                disabled && 'pointer-none',
            )}
        >
            {nights.map(night => {
                const index = night - 1;
                return (
                    <label
                        className="radio flex-1 sm:basis-auto has-[:checked]:bg-primary/20"
                        key={index}
                    >
                        <input
                            className="peer"
                            type="radio"
                            name="nights"
                            checked={value === index}
                            onChange={() => onChange(index)}
                        />
                        <span className="after:bg-primary peer-checked:before:border-primary">
                            {night}&nbsp;{night === 1
                            ? translate('night').toLowerCase()
                            : translate('nights').toLowerCase()}
                        </span>
                    </label>
                );
            })}
        </div>
    );
}
